module.exports = __webpack_public_path__ + "static/img/team_add_member.51fbd09.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/tutorial/img/team_add_member.png
// module id = dhWh
// module chunks = 1